import { Box, styled } from '@mui/material'

export const TitleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: theme.spacing(4),
  gap: theme.spacing(2),
  fontFamily: 'Poppins'
}))

export const BulletTypography = styled(Box)(({ theme }) => ({
  width: theme.spacing(1.5),
  height: theme.spacing(0.75),
  borderRadius: 2,
  backgroundColor: theme.palette.primary.main,
  fontFamily: 'Poppins'
}))

export const SepTitle = styled(Box)(() => ({
  flexGrow: 1,
  height: 1,
  backgroundColor: '#F6F7F8',
  fontFamily: 'Poppins'
}))

export const TitleMain = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  fontWeight: 600,
  fontSize: 16,
  lineHeight: 1.25,
  color: theme.palette.grey[800],
  fontFamily: 'Poppins'
}))
